import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HeadingLevel } from '@knorr-bremse-portals/ngx-components/components/variable-heading';
import { CaptionAttributes, CaptionEditorIds } from '../../types/figure';
import { SrcSetImageAttributes, ImageTopicAttributes, ImageLinkAttributes, SrcSetImageEditorIds, ImageTopicEditorIds, ImageLinkEditorIds, IMAGE_COMPONENT_NAME } from '../../types/image';
import { AnyInnerSection, InnerSection } from '../../types/section';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { OverlayFigureComponent } from '@knorr-bremse-portals/ngx-components/components/overlay-figure';
import { EditorIdDirective } from '../../directives/editor-id.directive';
import { OgImageDirective } from '../../directives/og-image.directive';
import { imageToPicture } from '../plain-image/plain-image.component';
import { AspectRatio, ColumnWidth } from '@knorr-bremse-portals/ngx-components';
import { ExternalVideoAttributes, ExternalVideoEditorIds, InternalVideoAttributes, InternalVideoEditorIds, PlainVideoComponent, VIDEO_COMPONENT_NAME } from '../plain-video/plain-video.component';
import { InnerSectionComponent } from '../inner-section/inner-section.component';

export type ImageOverlayFigureSection = InnerSection<
  SrcSetImageAttributes & Partial<CaptionAttributes> & Partial<ImageTopicAttributes> & Partial<ImageLinkAttributes> & { headingLevel?: HeadingLevel },
  SrcSetImageEditorIds | CaptionEditorIds | ImageTopicEditorIds | ImageLinkEditorIds | ['headingLevel'],
  typeof IMAGE_COMPONENT_NAME
>;

export type InternalVideoOverlayFigureSection = InnerSection<
  InternalVideoAttributes & Partial<CaptionAttributes> & { headingLevel?: HeadingLevel },
  InternalVideoEditorIds | CaptionEditorIds | ['headingLevel'],
  typeof VIDEO_COMPONENT_NAME
>;

export type ExternalVideoOverlayFigureSection = InnerSection<
  ExternalVideoAttributes & Partial<CaptionAttributes> & { headingLevel?: HeadingLevel },
  ExternalVideoEditorIds | CaptionEditorIds | ['headingLevel'],
  typeof VIDEO_COMPONENT_NAME
>;

export type VideoOverlayFigureSection = InternalVideoOverlayFigureSection | ExternalVideoOverlayFigureSection;

export function isVideoOverlayFigureSection(section: AnyInnerSection): section is VideoOverlayFigureSection {
  return section.component === VIDEO_COMPONENT_NAME;
}

export type VisualOverlayFigureSection = ImageOverlayFigureSection | VideoOverlayFigureSection;

@Component({
    selector: 'app-visual-overlayed-figure',
    imports: [
        OverlayFigureComponent,
        PictureComponent,
        EditorIdDirective,
        OgImageDirective,
        PlainVideoComponent,
    ],
    templateUrl: './visual-overlayed-figure.component.html',
    styleUrl: './visual-overlayed-figure.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisualOverlayedFigureComponent extends InnerSectionComponent<VisualOverlayFigureSection> {

  public rootColumns = input.required<ColumnWidth>()

  protected isVisualVideoSection = isVideoOverlayFigureSection;
  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;

}
